import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLProps<HTMLLabelElement>

function Label({ className, ...props }: Props) {
  return <label className={classNames(style.label, className)} {...props} />
}

export default Label
